(function() {
    'use strict';
    
a3_cabin_reports.controller('SupplyCtrl', SupplyCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name SupplyCtrl
    * @description 
    *  Manages the Supply Modal View
    * @ngInject
    */
function SupplyCtrl($scope, $timeout, $uibModalInstance, ModalDialogResultFactory, SupplyFactory, ACSupplyFactory, sup) {
		// setup supply types
		var smts = ACSupplyFactory.getACSuppliesFromStorageAsStrings();
		if (!(smts instanceof Array)) smts = [];
		$scope.supplyTypes = smts;

		$scope.clearField = clearField;
        // clear remarks function
		$scope.clearSupplyRemarks = clearSupplyRemarks;

		var result = ModalDialogResultFactory.createNew();

		if (sup == null) {
			result.Object = SupplyFactory.createNew();
			result.isInsertMode = true;
		} else {
			result.Object = SupplyFactory.fromObject(sup);
			result.isInsertMode = false;
		}

		$scope.sup = result.Object;

		$scope.ok = ok;
        $scope.cancel = cancel;

		$timeout(function() {
			$('.modal-supplies').find('textarea').each(function(index, item) {
				if (item.value != '')
					autoAdjustTextarea(item);
			});
		}, 500);
        
        /**
         * Clear Field
         * @memberof SupplyCtrl
         */
        function clearField(target, fieldName) {
			if (target[fieldName] == null || target[fieldName] == '') return false;
			bootbox.dialog({
				message: "Please confirm that you wish to clear this field",
				title: "<strong>Attention<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
						callback: function() {}
					},
					ok: {
						label: "Ok",
						className: "btn-warning",
						callback: function() {
							target[fieldName] = null;
							$scope.$apply();
							return true;
						}
					}
				}
			});
		}

        /**
         * Clear Supply Remarks
         * @memberof SupplyCtrl
         * @param {object} supply
         */
        function clearSupplyRemarks(sup) {
			$scope.clearField(sup, "Remarks");
			//sup.Remarks = null;
		}
        
        /**
         * Close modal after u check SupplyType
         * @memberof SupplyCtrl
         */
        function ok() {
			if ((result.Object.SupplyType == null) || (result.Object.SupplyType == ''))
				result.Object.SupplyType = '-';
			$uibModalInstance.close(result);
		}
 
        /**
         * Close modal
         * @memberof SupplyCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();